import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EnvironmentService, GridService } from '@core/services';

import { Column, Columns, SummaryRow, SummaryRowText } from '#types/grid';

@Component({
  selector: 'tr[z-grid-table-footer-cell]',
  templateUrl: './table-footer-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFooterCellComponent implements OnInit {
  destroy$ = new Subject<void>();

  @Input() gridId: string;
  @Input() columns: Columns;

  data$ = new BehaviorSubject<SummaryRow>(null);
  dataText$ = new BehaviorSubject<SummaryRowText>(null);

  displayColumns$ = new BehaviorSubject<string[]>([]);
  displayColumnsText$ = new BehaviorSubject<string[]>([]);

  constructor(public environmentService: EnvironmentService, public gridService: GridService) {}

  ngOnInit() {
    this.gridService
      .summaryRow$(this.gridId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((summaryRow) => {
        if (summaryRow) {
          this.displayColumns$.next(Object.keys(summaryRow));
          this.data$.next({ ...summaryRow });
        } else {
          this.displayColumns$.next([]);
          this.data$.next({});
        }
      });

    this.gridService
      .summaryRowText$(this.gridId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((summaryRowText) => {
        if (summaryRowText) {
          this.displayColumnsText$.next(Object.keys(summaryRowText));
          this.dataText$.next({ ...summaryRowText });
        } else {
          this.displayColumnsText$.next([]);
          this.dataText$.next({});
        }
      });
  }

  trackBy(_index: number, column: Column) {
    return column.key;
  }
}
